import React, { createContext, useContext, useState } from 'react';

interface CalendarSettingsType {
    view: 'day' | 'week' | 'month';
    showCPI: boolean;
    showServiceIcons: boolean;
    timeFormat: '12h' | '24h';
    setView: (view: 'day' | 'week' | 'month') => void;
    toggleCPI: () => void;
    toggleServiceIcons: () => void;
    settings: {
        colorMode: string;
        showCPI: boolean;
        showServiceIcons: boolean;
    };
    getEffectiveColorMode: (barberId: string) => string;
}

const CalendarSettingsContext = createContext<CalendarSettingsType | undefined>(undefined);

export const CalendarSettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [view, setView] = useState<'day' | 'week' | 'month'>('week');
    const [showCPI, setShowCPI] = useState(true);
    const [showServiceIcons, setShowServiceIcons] = useState(true);
    const [timeFormat] = useState<'12h' | '24h'>('12h');

    const toggleCPI = () => setShowCPI(prev => !prev);
    const toggleServiceIcons = () => setShowServiceIcons(prev => !prev);

    const settings = {
        colorMode: 'default',
        showCPI,
        showServiceIcons
    };

    const getEffectiveColorMode = (barberId: string) => {
        // Return color mode based on barber or default
        return 'default';
    };

    return (
        <CalendarSettingsContext.Provider value={{
            view,
            showCPI,
            showServiceIcons,
            timeFormat,
            setView,
            toggleCPI,
            toggleServiceIcons,
            settings,
            getEffectiveColorMode
        }}>
            {children}
        </CalendarSettingsContext.Provider>
    );
};

export const useCalendarSettings = () => {
    const context = useContext(CalendarSettingsContext);
    if (!context) {
        throw new Error('useCalendarSettings must be used within CalendarSettingsProvider');
    }
    return context;
};